import { useCallback, useState } from 'react';

import { mixpanelTrack } from '@revenuemarket/utils/mixpanel';
import { useRouter } from 'next/router';

import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import getCodefDownloadPath from '~utils/codef/getCodefDownloadPath';

import useCodef from './useCodef';

const useCertificate = () => {
  const router = useRouter();

  const [isVerifying, setIsVerifying] = useState(false);
  const { requestInitialization } = useCodef();

  const downloadCodefProgram = useCallback(() => {
    mixpanelTrack(MIXPANEL_EVENT.CERT.CLICK_INSTALL_CODEF);
    router.push(getCodefDownloadPath());
  }, [router]);

  const checkCodefInstalled = async (): Promise<{
    downloadNeeded: boolean;
  }> => {
    setIsVerifying(true);
    try {
      await requestInitialization();

      return {
        downloadNeeded: false,
      };
    } catch (error) {
      return {
        downloadNeeded: true,
      };
    } finally {
      setIsVerifying(false);
    }
  };

  return {
    downloadCodefProgram,
    checkCodefInstalled,
    isVerifying,
  };
};

export default useCertificate;
